const CDN = "https://nsk-cdn-static.tiendanube.com";

declare const __CDN_BUNDLE_VERSION__: string;

const BUNDLE_VERSION =
	typeof __CDN_BUNDLE_VERSION__ !== "undefined" && __CDN_BUNDLE_VERSION__
		? __CDN_BUNDLE_VERSION__
		: "0.28.3";

export type ScriptsProps = { withTelemetry?: boolean };

export function Scripts({ withTelemetry = false }: ScriptsProps) {
	const version = withTelemetry
		? `${BUNDLE_VERSION}-telemetry`
		: BUNDLE_VERSION;

	return (
		<>
			<script
				defer
				crossOrigin="anonymous"
				src={`${CDN}/nube-sdk-${version}.min.js`}
			/>
			<script
				defer
				crossOrigin="anonymous"
				src={`${CDN}/register-${version}.min.js`}
			/>
		</>
	);
}
